import { RotateCcw } from 'lucide-react';
import useStore from '../store/useStore';
import { Button } from '@/ui/button';

const ResponsiveWarning = () => {
  const setCurrentPage = useStore((s) => s.setCurrentPage);
  const setBookWithoutDesign = useStore((s) => s.setBookWithoutDesign);
  const setShowResponsiveWarning = useStore((s) => s.setShowResponsiveWarning);

  const handleBookCustomize = () => {
    // Navigate to booking flow
    setBookWithoutDesign(true);
    setShowResponsiveWarning(false);
    setCurrentPage('booking');
  };

  return (
    <div 
      className="fixed inset-0 z-[100] bg-slate-900/95 backdrop-blur-sm flex flex-col items-center justify-center p-8"
      data-testid="responsive-warning"
    >
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-slate-800 flex items-center justify-center">
          <RotateCcw className="h-10 w-10 text-teal-400" />
        </div>
        
        <h2 className="font-heading text-2xl font-bold text-white mb-4">
          Please rotate your device or increase your browser width.
        </h2>
        
        <p className="text-slate-400 mb-8">
          The editor requires a minimum width of 900px for the best editing experience.
        </p>

        <Button
          onClick={handleBookCustomize}
          className="bg-teal-500 hover:bg-teal-400 text-slate-900 font-semibold px-6 py-2"
          data-testid="book-customize-responsive-btn"
        >
          Book
        </Button>
      </div>
    </div>
  );
};

export default ResponsiveWarning;
